import { APP } from '../app/tokens';

export const PDF_VIEWER = {
  bgViewer: APP.bgDocViewer,
  bgSheet: APP.bgDocSheet,
  sheetShadow: APP.docSheetShadow,
  fieldUnsigned: '#D46A3A',
  fieldActive: '#D97645',
  fieldSigned: '#1B7A4B',
  fieldBgUnsigned: '#FEF3EC',
  fieldBgActive: '#FFF5ED',
  fieldBgSigned: '#F4FAF6',
  fieldBgOther: '#F5F2ED',
  fieldBorderOther: '#C5BFB8',
  thumbWidth: 120,     // display width
  thumbHeight: 176,    // display height
  railWidth: 148,      // thumb + padding + border space
  railPadding: 12,
  pageGap: 18,         // slightly tighter for more content
  toolbarHeight: 40,
  // v1 placement-redesign tokens
  swatchSize: 10,      // px — color dot in RecipientLegend
  markerLabelGap: 4,   // px — gap between marker and its type pill
  legendWidth: 200,    // px — RecipientLegend right rail width
} as const;
